import { useMutation } from "react-apollo-hooks";
import { closeProject } from "../../lib/queries/project";

const useCloseProject = (extProjectId: string) =>
  useMutation(closeProject, { variables: { extProjectId } });

export default useCloseProject;
